import { useCallback } from 'react';
import IconButton from '@mui/material/IconButton';
import { PlusIcon } from 'framework/ui/mui-builder';
import { UiThemeOverrider } from 'framework/uiTheme';
import { DropDownFilterInputLayout, ListFiltersLayout } from 'framework/list';
import OutcomesSensitiveAccordion from 'domain/projects/newProject/businessOutcomes/OutcomesSensitiveAccordion';
import {
  ACCESS_INFO_ACTIONS,
  ACCESS_INFO_SECTIONS,
  CHANGE_REQUEST_STATUS_OPTIONS,
  StatusFilter,
  useProjectFinanceService,
  useProjectSecurityContext,
  useNewProjectUrl,
  useProjectDataContext,
} from 'domain/shared/newProject';
import ChangeRequestListGrid from './ChangeRequestListGrid';
import ToggleSensitiveDataIconButton from './ToggleSensitiveDataIconButton';
import { SensitiveListElementLayout } from 'framework/sensitiveData';
import { openPageInNewTab } from 'framework/utils';

const ChangeRequestsList = () => {
  const { data } = useProjectDataContext();
  const { isAccessGranted } = useProjectSecurityContext();
  const { getCreateChangeRequestUrl, getSingleEntityUrl } = useNewProjectUrl();
  const { searchSensitiveProjectInfo } = useProjectFinanceService();

  const filters = (
    <UiThemeOverrider
      overriddenLayouts={{
        DropdownLayout: DropDownFilterInputLayout,
      }}
    >
      <ListFiltersLayout>
        <StatusFilter source="status" options={CHANGE_REQUEST_STATUS_OPTIONS} />
      </ListFiltersLayout>
    </UiThemeOverrider>
  );

  const renderActions = useCallback(() => {
    if (!isAccessGranted(ACCESS_INFO_SECTIONS.CHANGE_REQUEST, ACCESS_INFO_ACTIONS.MANAGE)) {
      return [];
    }
    return [
      <IconButton sx={{ p: 0, ml: 1 }} key="add" onClick={() => openPageInNewTab(getCreateChangeRequestUrl(data.id!))}>
        <PlusIcon />
      </IconButton>,
    ];
  }, [getCreateChangeRequestUrl, data, isAccessGranted]);

  const loadSensitiveData = (ids: string[]) =>
    searchSensitiveProjectInfo(ids).then(response =>
      Object.fromEntries(response.map(item => [item.id, { additionalBudgetAmount: item.value }])),
    );

  return (
    <SensitiveListElementLayout
      sensitiveDataIdSource="additionalBudgetAmountId"
      loadSensitiveDataMethod={loadSensitiveData}
      timerId={getSingleEntityUrl()}
      toggleSensitiveDataComponent={ToggleSensitiveDataIconButton}
    >
      <OutcomesSensitiveAccordion defaultExpanded title="Change requests" filters={filters} actions={renderActions()}>
        <ChangeRequestListGrid projectId={data.id} />
      </OutcomesSensitiveAccordion>
    </SensitiveListElementLayout>
  );
};
export default ChangeRequestsList;
